module.exports = __webpack_public_path__ + "img/e8fde76.png";